import React from 'react';
import Bullet from 'components/prism/bullet';
import { withRouter } from 'react-router-dom';

export const Pathway = ({ pathway, multiColumn, history }) => {
    return (
        <>
            <h2 className="mb20">Your Learning Pathway</h2>
            <div className="prism-content-box">
                {multiColumn && (
                    <div className="prism-banner">
                        <img src={pathway.image} />
                    </div>
                )}
                <div className="prism-content">
                    <Bullet type="pathway" />
                    <div className="prism-progress">
                        <div className="prism-progress-bar">
                            <div style={{ width: `${pathway.progress}%` }} />
                        </div>
                        <div>{pathway.progress}%</div>
                    </div>
                    <h3>{pathway.name}</h3>
                    {pathway.description && <p>{pathway.description}</p>}
                    <button className="btn btn-primary" onClick={() => history.push(`/develop/pathways`)}>
                        {pathway.progress ? 'Resume' : 'Start'}
                    </button>
                    <div className="split-col">
                        <Bullet isDate value={pathway.due} />
                        {pathway.duration && <Bullet isDuration value={pathway.duration} />}
                    </div>
                </div>
            </div>
        </>
    );
};

export default withRouter(Pathway);
